export type BoardTag = {
  tag: 'predeal' | 'deal' | 'flop' | 'turn' | 'river' | 'showdown'
  description: string
}

export type PreDeal = BoardTag & { tag: 'predeal' }
export type Deal = BoardTag & { tag: 'deal' }
export type Flop = BoardTag & { tag: 'flop' }
export type Turn = BoardTag & { tag: 'turn' }
export type River = BoardTag & { tag: 'river' }
export type Showdown = BoardTag & { tag: 'showdown' }

export type BoardState = PreDeal | Deal | Flop | Turn | River | Showdown

export type BoardStateTag = BoardTag['tag']
